export class NumberUtil {

    static parseFloat(value: any) {
        if (!value) {
            return;
        }
        return parseFloat(value);
    }

    static toFixed(value: any, fixedValue: number) {
        if (!value) {
            return;
        }
        return parseFloat(value).toFixed(fixedValue);
    }

    static toFloat(value: any) {
        const num = parseFloat(value);

        if (isNaN(num)) {
            return null;
        }

        return parseFloat(num.toFixed(1));
    }

    static convert(value: any) {
        if (typeof value !== 'string') {
            return value;
        }
        return Number(value.replace(',', '.'));
    }

    static roundDown(value: number) {
        return Math.floor(value * 2) / 2;
    }

}
